module.exports = __webpack_public_path__ + "img/h5banner_id_ID.bc87f4d0.jpg";